import { render, staticRenderFns } from "./ComtrexSettings.vue?vue&type=template&id=101ac106"
import script from "./ComtrexSettings.vue?vue&type=script&lang=js"
export * from "./ComtrexSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports